const textTransform = () => {
	const text = $('.textTransform')
	const textList = $('.js-textTransform-list')
	let tl = new TimelineMax({
		repeat: -1,
		yoyo: false,
		repeatDelay: 0,
	})
	text.css({ color: '#2a4971' })
	textList.find('input').each(function() {
		tl.to(text, 1, {
			text: {
				value: $(this).val(),
				padSpace: true,
				ease: Linear.easeNone,
			},
			delay: 2,
		})
	})
}
export { textTransform }
